export const KPI_COLORS = {
  total: '#6C63FF',
  added: '#22C55E',
  modified: '#3B82F6',
  deleted: '#EF4444',
};

export const KPI_THEME = {
  total: {
    color: '#7C4DFF',
    bg: '#F4F0FF',
    iconBg: '#E8DFFF',
  },

  added: {
    color: '#22C55E',
    bg: '#ECFDF3',
    iconBg: '#D9FBE8',
  },

  modified: {
    color: '#3B82F6',
    bg: '#EEF6FF',
    iconBg: '#DCEBFF',
  },

  deleted: {
    color: '#F05252',
    bg: '#FFF3F5',
    iconBg: '#FFE3E7',
  },
};